/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/platform/design-system/components/ui/Skeleton.tsx
 * layer: web
 * area: components
 * kind: component
 * web_root: components
 * relpath: web/src/platform/design-system/components/ui/Skeleton.tsx
 * filename: Skeleton.tsx
 * extension: tsx
 * ---
 * hyperion-index:end
 */

import { HTMLAttributes } from 'react';
import { clsx } from 'clsx';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'motion-loading-pulse rounded-md bg-[rgb(var(--color-bg-tertiary))]',
        className
      )}
      {...props}
    />
  );
}
